import * as React from "react";

import { Doc } from "affinityUI/structures/doc";

import supportPage from "./assets/Support page.png";
import supportSectionNavBar from "./assets/Support section in navigation bar.png";
export const SupportSection: React.FC = () => {
  return (
    <Doc.Section title="Support Section">
      <p>
        Information on how to contact Entia, Cookie policy and other helpful content can be viewed in the “Support”
        section in the navigation bar at the top of the screen.
      </p>
      <Doc.Illustration src={supportSectionNavBar} label="Support section in navigation bar" />
      <Doc.Illustration src={supportPage} label="Support page" />
    </Doc.Section>
  );
};
